<template>
    <div>
        <el-row>
            <h3>角色信息</h3>
            <el-form :model="form" ref="form" label-width="100px" style="width:40%;">
                <el-form-item prop="name" label="角色名称" :rules="rules.name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="角色描述">
                    <el-input v-model="form.description" type="textarea"></el-input>
                </el-form-item>
            </el-form>
        </el-row>

        <authority ref="menus" @getMenu="getMenu" :appPermissions="form.appDtoList"/>

        <el-row style="margin: 10px 0;text-align:center;">
            <el-button type="primary" @click="saveValid">保存</el-button>
            <el-button @click="cancel(false)">取消</el-button>
        </el-row>
    </div>
</template>
<script>
import { Loading } from "element-ui"
import Authority from './Authority'
export default {
    components: { Authority },
    props: {
        roleId: {
            type: [String, Number]
        }
    },
    data: vm=>({
        rules: {
            name: [{ required: true, message: '必填项', trigger: 'blur'}]
        },
        form: {
            id: 0,
            name: '',
            description: '',
            // apps: [],
            // appPermissions: [],
            appIds: [], //勾选的菜单
            buttonIds: [], //勾选的操作
            appDtoList: [], //返回的已勾选的菜单和操作
        },
    }),
    created(){
        if(this.roleId){
            this.findById(this.roleId)
        }
    },
    methods: {
        // 角色详情
        findById(id){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios
                .get(this.baseUrl3 + "role/findById/" + id)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.form = data
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        getMenu(val){

            // this.form.appPermissions = val
            this.form.appIds = val.appIds
            this.form.buttonIds = val.buttonIds
        },
        saveValid(){
            this.$refs.form.validate(valid => {
                if(valid){
                    this.save()
                }
            })
        },
        save(){
            this.$refs.menus.getCheckedAll()

            let url = this.baseUrl3
            if(this.roleId){
                // 编辑
                url +=  "role/edit"
            }else{
                // 新增
                url +=  "role/add"
            }

            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            let model = this.form

            this.$axios
                .post(url, model)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.$message.success('操作成功')
                        this.cancel(true)

                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        cancel(flag){
            this.$emit('roleAddCallback', flag)
        },

    }
}
</script>
